import { isEmpty } from './is-empty';

export const clearObj = (obj: Record<string, any>): Record<string, any> =>
  Object.entries(obj)
    .filter(([, value]) => !isEmpty(value))
    .reduce<any>((acc, [key, value]) => ((acc[key] = value), acc), {});
